import { useContext, useEffect, useRef, useState } from 'react';
import './inbox.css';
import {Button, LeftPanel, Modal} from '@nxtvid/component-library';
import { UserContext } from '../../Contexts/UserContext';
import InboxTopPanel from './components/InboxTopPanel';
import InboxChatContainer from './components/InboxChatContainer';
import AutoGrowingTextarea from './components/AutoGrowingTextArea';
import getChatSessions from './utilities/getChatSessions';
import getChatMessages from './utilities/getChatMessages';
import { useSocket } from '../../Contexts/WebSocketContext';
import handleSendMessage from './utilities/handleSendMessage';
import { markAllAsRead } from './utilities/markAllAsRead';
import { getTypingTextForSession } from './utilities/getTypingTextForSession';
import { handleViewRFP } from './utilities/handleViewRFP';
import { requestPayment } from './utilities/requestPayment';
import { DollarSign } from 'lucide-react';
import { handleCancelProject } from './utilities/handleCancelProject';
import { handleCompleteProject } from './utilities/handleCompleteProject';



const Inbox = () =>{
    const {userInfo} = useContext(UserContext);
    const sendIcon = require('../../Images/send-icon.png')
    const { socket, sendMessage, isReady, chatMessages, setChatMessages, unreadMap, setUnreadMap, selectedChatSession, setSelectedChatSession, chatSessions, setChatSessions, setTotalUnreadCount, typingMap, setTypingMap, sessionTypingMap } = useSocket();
    const [message, setMessage] = useState('');
    const lastActiveSessionRef = useRef(null);
    const [paymentRequestAmount, setPaymentRequestAmount] = useState('');
    const [paymentRequestDescription, setPaymentRequestDescription] = useState('');
    const [requestPaymentAlert, setRequestPaymentAlert] = useState("Any money paid by the client will be held in escrow until the project is marked as complete. This is to protect both the client and the videographer. If you have any questions, please contact support at support@nxtvid.io.");
    const [isPaymentRequestModalOpen, setIsPaymentRequestModalOpen] = useState(false);
    const [isBannerOpen, setIsBannerOpen] = useState(false);
    const [isManageProjectModalOpen, setIsManageProjectModalOpen] = useState(false);
    const [isCancelProjectModalOpen, setIsCancelProjectModalOpen] = useState(false);
    const [isCompleteProjectModalOpen, setIsCompleteProjectModalOpen] = useState(false);
    const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
    const [alertModalText, setAlertModalText] = useState('');
    const [alertModalLink, setAlertModalLink] = useState('');

    useEffect(() => {
        document.querySelectorAll('.unread-badge').forEach(el => el.remove());
        
  chatSessions.forEach((item, index) => {
    const unreadCount = unreadMap[item._id] || 0;

    if (unreadCount > 0) {
      const targetEl = document.getElementById(`left-panel__content-item-${item._id}`);

      if (targetEl && !targetEl.querySelector('.unread-badge')) {
        const badge = document.createElement('div');
        badge.className = 'unread-badge';
        badge.textContent = unreadCount;

        Object.assign(badge.style, {
          position: 'absolute',
          top: '8px',
          right: '12px',
          backgroundColor: '#DF7C52',
          color: 'white',
          borderRadius: '9999px',
          fontSize: '12px',
          width: '20px',
          height: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pointerEvents: 'none',
          zIndex: '10',
        });

        targetEl.style.position = 'relative';
        targetEl.appendChild(badge);
      }
    }
  });
}, [chatSessions, unreadMap]);



    const handleSelectChatSession = (session) => {
        lastActiveSessionRef.current = selectedChatSession?._id;
        if (
    lastActiveSessionRef.current &&
    userInfo
  ) {
    // User was typing in a previous session – clear it
    socket.send(JSON.stringify({
      type: 'chat:typing',
      payload: {
        sessionId: lastActiveSessionRef.current,
        userId: userInfo._id,
        isTyping: false
      }
    }));
  }


  document.getElementsByClassName('inbox-left-panel')[0]
    ?.classList.toggle('inbox-left-panel--hidden');

  // No more getElementById, let React handle UI changes
  markAllAsRead(session._id, userInfo._id, setTotalUnreadCount);
  setSelectedChatSession(session);
  console.log('selected chat session changed')
  setUnreadMap(prevMap => ({
    ...prevMap,
    [session._id]: 0
  }));
};

    

    useEffect(() => {

  if (!selectedChatSession || !userInfo || !isReady) return;

  const loadMessages = async () => {
    try {
      const messages = await getChatMessages(selectedChatSession._id);
      setChatMessages(messages);
    } catch (err) {
      console.error('Message load failed:', err);
    }
  };
  setTypingMap({});
  loadMessages();
}, [selectedChatSession, userInfo, isReady]);


    useEffect(() => {
        const chatContainer = document.querySelector('.inbox-chat-messages');
        if (chatContainer) {
            chatContainer.scrollTo({
                top: chatContainer.scrollHeight,
                behavior: 'smooth'
            });
        }
    }, [selectedChatSession, chatMessages]);
    

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault(); 
                handleSubmit();
            }
        }
        const textarea = document.querySelector('.inbox-text-input-panel__input textarea');
        if (textarea) {
            textarea.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            if (textarea) {
                textarea.removeEventListener('keydown', handleKeyDown);
            }
        }
    }, [message, selectedChatSession, userInfo, isReady]);

    const handleSubmit = () => {
    if (message.trim() === "") return;

    handleSendMessage(socket, {
      sessionId: selectedChatSession._id,
      fromUserId: userInfo._id,
      fromRole: selectedChatSession.videographerId === userInfo._id ? 'videographer' : 'client',
      content: message.trim(),
    });

    setMessage("");
    // set the selectedChatSession.lastChatMessageContent within the chatSessions array to the latest message and set it to the first element of the array
    const updatedChatSessions = chatSessions.map(session => {
        if (session._id === selectedChatSession._id) {
            return {
                ...session,
                lastChatMessageContent: message.trim(),
                lastChatMessageSent: new Date().toISOString()
            };
        }
        return session;
    });
    setChatSessions(updatedChatSessions);
  };

  useEffect(() => {
  if (!selectedChatSession || !userInfo || !isReady) return;

  sendMessage('chat:register', {
    userId: userInfo._id,
    sessionId: selectedChatSession._id,
    isActive: true,
  });
}, [selectedChatSession, userInfo, isReady]);


//use effect to see if paymentRequestAmount is an integer. If not, set paymentRequestAlert to 'Please enter a valid amount.' else set it to an empty string
useEffect(() => {
    if (paymentRequestAmount && !/^\d+$/.test(paymentRequestAmount)) {
        setRequestPaymentAlert('Please enter a valid amount. Exclude any currency symbols or decimal points.');
    } else {
        setRequestPaymentAlert('Any money paid by the client will be held in escrow until the project is marked as complete. This is to protect both the client and the videographer. If you have any questions, please contact support at support@nxtvid.io.');
    }
}
, [paymentRequestAmount]);


    return(
        <div className="inbox-body">
            <LeftPanel className='inbox-left-panel' title='Inbox' sectionsPlaceHolder='No messages'
                sections={[
                    {
                        sectionTitle: 'Active Projects',
                        sectionsPlaceHolder: 'No Active Projects',
                        startCollapsed: false,
                        sectionContent: chatSessions.filter(item=>item.status==='active').map((item, index) => {
                            return ({
                            sectionSubTitle: item.title,
                            card: true,
                            sectionDetails: getTypingTextForSession(item._id, sessionTypingMap, userInfo._id) ? getTypingTextForSession(item._id, sessionTypingMap, userInfo._id, item.videographerId, item.clientId, item.videographerName, item.clientName) : item.lastChatMessageContent,
                            detailsItalisized: true,
                            detailsEllipses: true,
                            onClick: () => handleSelectChatSession(item),
                            id: `left-panel__content-item-${item._id}`,
                            className: `left-panel__content-item ${selectedChatSession && selectedChatSession._id === item._id ? 'selected' : ''}`,
                            selected: selectedChatSession && selectedChatSession._id === item._id,
                            _id: item._id,
                            index: index
                        })})
                    },
                    {
                      sectionTitle: 'Completed Projects',
                      sectionsPlaceHolder: 'No Completed Projects',
                      startCollapsed: true,
                        sectionContent: chatSessions.filter(item=>item.status==='completed').map((item, index) => {
                            return ({
                            sectionSubTitle: item.title,
                            card: true,
                            sectionDetails: getTypingTextForSession(item._id, sessionTypingMap, userInfo._id) ? getTypingTextForSession(item._id, sessionTypingMap, userInfo._id, item.videographerId, item.clientId, item.videographerName, item.clientName) : item.lastChatMessageContent,
                            detailsItalisized: true,
                            detailsEllipses: true,
                            onClick: () => handleSelectChatSession(item),
                            id: `left-panel__content-item-${item._id}`,
                            className: `left-panel__content-item ${selectedChatSession && selectedChatSession._id === item._id ? 'selected' : ''}`,
                            selected: selectedChatSession && selectedChatSession._id === item._id,
                            _id: item._id,
                            index: index
                        })})
                    },
                    {
                        sectionTitle: 'Canceled Projects',
                        sectionsPlaceHolder: 'No Canceled Projects',
                        startCollapsed: true,
                        sectionContent: chatSessions.filter(item=>item.status==='canceled').map((item, index) => {
                            return ({
                            sectionSubTitle: item.title,
                            card: true,
                            sectionDetails: getTypingTextForSession(item._id, sessionTypingMap, userInfo._id) ? getTypingTextForSession(item._id, sessionTypingMap, userInfo._id, item.videographerId, item.clientId, item.videographerName, item.clientName) : item.lastChatMessageContent,
                            detailsItalisized: true,
                            detailsEllipses: true,
                            onClick: () => handleSelectChatSession(item),
                            id: `left-panel__content-item-${item._id}`,
                            className: `left-panel__content-item ${selectedChatSession && selectedChatSession._id === item._id ? 'selected' : ''}`,
                            selected: selectedChatSession && selectedChatSession._id === item._id,
                            _id: item._id,
                            index: index
                        })})
                    }
                ]}
            />
            <InboxTopPanel userInfo={userInfo} selectedChatSession={selectedChatSession} />
            <InboxChatContainer selectedChatSession={selectedChatSession} messages={chatMessages} userInfo={userInfo} />
            <div className='typing-indicator'>
                <i>
                    {getTypingTextForSession(selectedChatSession?._id, sessionTypingMap, userInfo._id, selectedChatSession?.videographerId, selectedChatSession?.clientId, selectedChatSession?.videographerName, selectedChatSession?.clientName)}
                </i>
            </div>
            {selectedChatSession ? <div className='inbox-feature-buttons'>
              <div className='view-RFP-button' onClick = {()=> handleViewRFP(selectedChatSession.rfpId, selectedChatSession.clientId)}>View RFP</div>
              {userInfo._id === selectedChatSession?.clientId ? <div className = 'manage-project-button' onClick={()=>{setIsManageProjectModalOpen(true)}} >Manage Project</div> : <div onClick={()=>{setIsPaymentRequestModalOpen(true); setPaymentRequestAmount(''); setPaymentRequestDescription(''); setRequestPaymentAlert('Any money paid by the client will be held in escrow until the project is marked as complete. This is to protect both the client and the videographer. If you have any questions, please contact support at support@nxtvid.io.')}} className='payment-button'>Request Payment</div>}
              
            </div>: null}
            
            <div className='inbox-text-input-panel'>
                <div className='inbox-text-input-panel__input'>
                    <AutoGrowingTextarea selectedChatSession = {selectedChatSession} placeholder='Type a message...' message={message} setMessage={setMessage} />
                </div>
                <div className='inbox-text-input-panel__send-button'>
                    <Button type='primary' size='small' icon = {sendIcon} onClick={handleSubmit}/>
                </div>
            </div>
            {isPaymentRequestModalOpen ? <Modal className='paymentRequestModal' onClose={()=>setIsPaymentRequestModalOpen(false)} onConfirm = {()=>requestPayment(paymentRequestAmount, paymentRequestDescription, selectedChatSession, setRequestPaymentAlert, socket, setIsPaymentRequestModalOpen, userInfo, setAlertModalText, setAlertModalLink, setIsAlertModalOpen)} small_subtitle={requestPaymentAlert} confirm_button_text='Request Payment' type='form' form_fields = {[{field_label: 'Amount', field_type:'text', field_required:true, field_placeholder_text:'e.g., 2000', field_state:paymentRequestAmount, field_set_state:setPaymentRequestAmount},{field_label:'Description', field_required: true, field_type:'text', field_placeholder_text:`e.g., 2-Day Shoot for ${selectedChatSession.title}`, field_state:paymentRequestDescription, field_set_state:setPaymentRequestDescription}, {field_label:'Amount you will recieve', field_placeholder_text:'13% fee deducted', disabled:true, field_state:parseInt(paymentRequestAmount) ? `$${(parseInt(paymentRequestAmount) * 0.87).toFixed(2)}` : null }]} title='Request a Payment' />: null}
            {selectedChatSession ? <div className = 'total-amount-paid-banner'><DollarSign onClick={() => setIsBannerOpen(prev => !prev)}  className='dollar-sign-inbox-button'/><div className={`total-amount-paid-text ${isBannerOpen ? 'open' : 'closed'}`}>&nbsp;&nbsp;Total Amount Paid: ${selectedChatSession.totalAmountPaid ? ((selectedChatSession.totalAmountPaid / 100) / 1.13 ).toFixed(2) : '0.00'}&nbsp;</div></div> : null}
            {isManageProjectModalOpen ? <Modal className='manageProjectModal' title='Manage Project' type='empty' onClose={()=>setIsManageProjectModalOpen(false)} children = {
              <div className='manage-project-modal-buttons'>
                <Button label='Mark Project as Complete' size='large' onClick={()=>{setIsManageProjectModalOpen(false); setIsCompleteProjectModalOpen(true)}}/>
                <Button type='destructive' label='Cancel Project' size = 'large' onClick={()=>{setIsManageProjectModalOpen(false); setIsCancelProjectModalOpen(true)}}/>
              </div>
            }/>:null}
            {isCancelProjectModalOpen ? <Modal className='cancel-project-modal' onClose={()=>{setIsCancelProjectModalOpen(false)}} title='Cancel Project' type='confirm' cancel_button_text='Nevermind' confirm_button_text='Cancel Project' description='If you cancel now, only 50% of your payment (excluding the service fee) will be refunded. The remaining amount covers time and preparation already invested by your creator.' onConfirm={()=>handleCancelProject(setIsCancelProjectModalOpen, socket, selectedChatSession, userInfo)}/>:null}
              {isCompleteProjectModalOpen ? <Modal className='complete-project-modal' onClose={()=>{setIsCompleteProjectModalOpen(false)}} title='Mark Project as Complete' type='confirm' cancel_button_text='Nevermind' confirm_button_text='Mark as Complete' description='This will mark the project as complete and release the payment to the creator. This action cannot be undone.' isOpen={isCompleteProjectModalOpen} onConfirm={()=>{handleCompleteProject(setIsCompleteProjectModalOpen, socket, selectedChatSession, userInfo)}}/>:null}
              {isAlertModalOpen ? <Modal className='alert-modal' type='confirm' confirm_button_text='Create Account' cancel_button_text='Maybe Later' onClose={()=>setIsAlertModalOpen(false)} title='Complete Stripe Account' description={alertModalText} onConfirm = {()=>window.open(alertModalLink, '_blank')}/> : null}
        </div>
    )



}

export default Inbox;